const r=({palette:t,vars:o})=>({styleOverrides:{root:{backgroundColor:((o==null?void 0:o.palette)||t).background.backdrop}}});export{r as default};
